/** Pessoa ou cliente sem foto: duas iniciais. Nunca foto de banco de imagem. */
export function Iniciais({ nome }: { nome: string }) {
  const partes = nome.trim().split(/\s+/).filter((p) => p.length > 2 || /^[A-ZÀ-Ý]/.test(p));
  const ini = ((partes[0]?.[0] ?? "?") + (partes.length > 1 ? partes[partes.length - 1]![0] : "")).toUpperCase();
  return (
    <span aria-hidden className="inline-grid size-6 shrink-0 place-items-center rounded-pilula bg-superficie-2 text-meta font-medium text-texto-3">
      {ini}
    </span>
  );
}
